export default __webpack_public_path__ + "static/media/color-logo.493e6f3a.svg";